/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_NoneInputs */

const en_group_none = /** @type {(inputs: Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No grouping`)
};

const de_group_none = /** @type {(inputs: Group_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Gruppierung`)
};

/**
* | output |
* | --- |
* | "No grouping" |
*
* @param {Group_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const group_none = /** @type {((inputs?: Group_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_group_none(inputs)
	return en_group_none(inputs)
});